import click from "../sounds/soft_click.wav";

export const buttonClick = new Audio(click);
buttonClick.volume = 0.1;